export const StoriesData = [
  {
    "id": "1",
    // "imageUrl": "https://backendtestinternal.s3.amazonaws.com/ChatGPT%20Image%20Feb%2018%2C%202026%2C%2007_19_50%20PM.png",
    "backgroundImage": "https://d2lyw5vkb9es5b.cloudfront.net/unified-patient-provider-digital-ecosystem1.webp",
    "customer": "ABA Therapy Provider (US)",
    "headline": "Connected CRM, EHR, and website to help patients and providers",
    "detailPageHeadline": "Connected CRM, EHR, and website to help patients and providers",
    "url": "unified-patient-provider-digital-ecosystem",
    "industry": "Healthcare",
    "description": "Connected CRM, EHR, and website to help patients and providers access what they need at the time they need building the trust in the care received.",
    "impact": "Easy access of PHI data and health documents via portals for both patients and care providers.",
    "techonolgyStack": [
      {
        "id": "1",
        "name": "Salesforce"
      },
      {
        "id": "2",
        "name": "Microsoft SharePoint"
      },
      {
        "id": "3",
        "name": "Epic EHR"
      }
    ],
    "storyDetail": `<div class="container">
  <div class="storyBlock" style="padding:6rem 0; color:#292929;">
    <h2>Making health information access simple, safe, and trusted
</h2>

    <p>
     In today’s digital world, people expect fast, seamless access to the information that matters most  whether it’s checking a bank balance or reviewing medical records. But in healthcare, access to protected health information (PHI) is often fragmented, delayed, or buried behind disconnected systems.
    </p>

    <p>
     For the ABA Therapy Provider, patients, families, and clinicians struggled with inconsistent access to essential health documents, progress notes, and care plans. Providers navigating multiple portals and email systems faced administrative friction. Families seeking progress reports or PHI had limited real-time visibility. The experience introduced unnecessary delays, impacted care coordination, and risked eroding trust.
    </p>

    <p>
    Leadership recognized that improving access was not a convenience  it was essential to improving care, strengthening trust, and empowering both patients and care teams.
    </p>
  </div>
</div>
<div class="container">
    <div class="threeGrid">
        <img src="https://d2lyw5vkb9es5b.cloudfront.net/unified-patient-provider-digital-ecosystem2.webp" alt="" class="gridImg">
        <img src="https://d2lyw5vkb9es5b.cloudfront.net/unified-patient-provider-digital-ecosystem3.webp" alt="" class="gridImg">
        <img src="https://d2lyw5vkb9es5b.cloudfront.net/unified-patient-provider-digital-ecosystem4.webp" alt="" class="gridImg">
    </div>
</div>


<div class="container storyBlock" style="color:#292929; padding-bottom:6rem;">
  <h2>
  Reimagining access with connected CRM, EHR, and patient portals 
  </h2>

<p>
    To bring this vision to life, the provider partnered with Antrazal to build a unified platform that seamlessly connects patient data from Epic EHR into <a href="/services/salesforce-health-cloud" title="Salesforce Health Cloud Implementation">Salesforce Health Cloud</a>, with SharePoint powering secure document storage and retrieval.
  </p>
  <p>
    Antrazal implemented <a href="/services/salesforce-implementation" title="Salesforce CRM Implementation Services">Salesforce</a> as the central experience layer for patient and provider engagement. Epic EHR was integrated in real time using <a href="/services/fhir-and-hl7-integration" title="FHIR and HL7 Integration Services">FHIR APIs</a> to ensure clinical data  including PHI, progress notes, therapy plans, and histories  flowed securely into Salesforce without manual entry. SharePoint served as the trusted repository for health documents, securely surfaced through connected <a href="/services/salesforce-experience-cloud" title="Salesforce Experience Cloud Portals">Experience Cloud portals</a>.
  </p>

  <p>
   The newly connected ecosystem enabled:
       <ul>
      <li> Patients to securely view PHI and health documents via a personalized portal</li>
      <li>Care providers to access up-to-date clinical information in a single interface</li>
      <li>Administrative teams to reduce manual requests and repetitive tasks</li>
    </ul>
  </p>
  <p>By replacing fragmented access points with a single, connected experience, the organization created an environment where users could access what they needed, when they needed it  strengthening trust in care and reducing operational friction. <p/>
</div>
<div
  class="storyBlock"
  style="
    color:#292929;
    background-image:url('https://d2lyw5vkb9es5b.cloudfront.net/unified-patient-provider-digital-ecosystem5.webp');
    background-size:cover;
    background-position:top;
    background-repeat:no-repeat;
    width:100%;
    aspect-ratio:20/9;
    margin-bottom:6rem;
  ">
</div>

<div class="container" style="color:#292929; padding-bottom:6rem;">
  <section class="blogCountUpSection storyBlock">
    <div class="blogCountUpSection__wrapper">

      <div class="blogCountUpSection__left">
        <h1>
            Real impact achieved through connected systems and smarter workflows
        </h1>
      </div>

      <div class="blogCountUpSection__right">

        <div class="blogCountUpSection__stat">
          <span class="blogCountUpSection__number">$2M</span>
          <p>US Dollars saved through streamlined PHI exchange and reduced administrative overhead</p>
        </div>

        <div class="blogCountUpSection__stat">
          <span class="blogCountUpSection__number">30%</span>
          <p>Productivity boost for teams working with PHI data</p>
        </div>

        <div class="blogCountUpSection__stat">
          <span class="blogCountUpSection__number">27%</span>
          <p>Higher customer retention driven by improved transparency and access to care information</p>
        </div>
      </div>
    </div>
  </section>
</div>


<div class="container storyBlock" style="color:#292929; padding-bottom:6rem;">
  <h2>The ROI of connected health access</h2>

  <p>Transforming access to health information quickly produced measurable outcomes for both users and the organization.</p>

  <p>
    By consolidating data from Epic EHR into <a href="/services/salesforce-health-cloud" title="Salesforce Health Cloud for Healthcare Providers">Salesforce Health Cloud</a> and surfacing it via connected portals:
    <ul>
      <li>Patients and families gained real-time, secure access to their own health information</li>
      <li>Care teams reduced administrative tasks and improved collaboration</li>
      <li>Trust in care consistency and transparency increased among stakeholders</li>
    </ul>
  </p>

  <p>
  What was once a fragmented, manual process became a connected, intuitive experience  one that reinforces trust, supports clinical decision-making, and improves operational efficiency.
</p>
</div>


<div
  class="storyBlock"
  style="
    color:#292929;
    background-image:url('https://d2lyw5vkb9es5b.cloudfront.net/unified-patient-provider-digital-ecosystem6.webp');
    background-size:cover;
    background-position:top;
    background-repeat:no-repeat;
    width:100%;
    aspect-ratio:20/9;
    margin-bottom:6rem;
  ">
</div>


<div class="container storyBlock" style="color:#292929; padding-bottom:6rem;">
  <h2>Building a future-ready platform for patient-centric care</h2>

 <p>
    Today, the ABA Therapy Provider operates with a fully connected care platform powered by <a href="/services/salesforce-health-cloud" title="Salesforce Health Cloud Implementation Services">Salesforce Health Cloud</a>.
  </p>
  <p>
   Real-time, connected health information is now accessible from a central experience layer, enabling faster decision-making, reducing administrative friction, and improving satisfaction for families and clinicians.
  </p>

  <p>
  With Salesforce as the backbone, Epic as the clinical source of truth, and SharePoint as the secure content repository  and with Antrazal as its implementation partner  the organization has established the digital foundation it needs to grow, innovate, and deliver trusted care experiences at scale
  </p>
</div>`
  },
  {
    "id": "2",
    "order": 2,
    "imageUrl": "https://backendtestinternal.s3.amazonaws.com/ChatGPT%20Image%20Feb%2023%2C%202026%2C%2012_25_20%20PM.jpg",
    "backgroundImage":
      "https://d2lyw5vkb9es5b.cloudfront.net/proven-revenue-smartly-delivered1.webp",
    "Brandlogo": "https://d2lyw5vkb9es5b.cloudfront.net/proven-revenue-smartly-delivered_Logo.webp",
    "customer": "Elements Group",
    "headline": "Proven Revenue, Smartly Delivered",
    "url": "proven-revenue-smartly-delivered",
    "detailPageHeadline": "Proven Revenue, Smartly Delivered",
    "industry": "Hospitality",
    "description": "Elements Dining Group scaled rapidly, but disconnected systems  OpenTable for reservations and a separate CRM for billing  created gaps between promotional discounts and financial records. Revenue wasn’t lost, but visibility and alignment were.",
    "impact": "The transformation standardized discounts, enabled real-time revenue visibility, improved campaign ROI tracking, eliminated manual reconciliation, and restored executive confidence through a single, reliable source of truth. ",
    "techonolgyStack": [
      {
        "id": "1",
        "name": "Salesforce Sales Cloud"
      },
      {
        "id": "2",
        "name": "Salesforce CPQ"
      },
      {
        "id": "3",
        "name": "Salesforce Marketing Cloud"
      }
    ],
    "storyDetail": `<div class="container">
  <div class="storyBlock" style="padding:6rem 0; color:#292929;">
    <h2>Growth Exposed the Gaps
    </h2>

    <p>
      Elements Dining Group was scaling rapidly. Reservations were increasing, marketing campaigns were driving demand,
      and promotional strategies were becoming more ambitious. On the surface, performance looked strong.
    </p>

    <p>
      Behind the scenes, however, revenue visibility was weakening. </p>

    <p>
      Reservations and discounts were managed through OpenTable, while billing and financial records were maintained in
      a separate internal CRM. Each system performed its role effectively, yet they were never designed to operate as a
      unified revenue ecosystem.
    </p>
    <p>
      As a result, promotional discounts applied at booking did not consistently flow into invoices or financial
      reports. The customer promise and the financial record were not always aligned.
    </p>
    <p>Growth was accelerating  but operational clarity was not.</p>
  </div>
</div>

<div class="storytestimonialContainer" style="color:#292929;">
  <div class="storytestimonialLeftDiv">
    <img src="https://d2lyw5vkb9es5b.cloudfront.net/proven-revenue-smartly-delivered2.webp"
      alt="Antrazal Blog Image">
  </div>

  <div class="storytestimonialRightDiv">
    <h1>
      "The mainstay of our strategy is to offer a level of client focus that is superior to that offered by our
      competitors. "
    </h1>
    <p class="storytestimonialName">Ali Gök</p>
    <p class="storytestimonialRole">Founder and Managing Director</p>
  </div>
</div>

<div class="container storyBlock" style="color:#292929; padding-bottom:6rem;">
  <h2>
    The Revenue Disconnect

  </h2>

  <p>
    The core issue was not technology failure; it was architectural fragmentation.
  </p>

  <p>
    Discount logic lived in one environment. Revenue recognition lived in another. Marketing performance data lived
    somewhere else entirely. As transactions moved from reservation to invoice, promotional adjustments were not
    automatically validated within the financial workflow.


  </p>
  <p>
    This created subtle but compounding friction. Finance teams spent time reconciling discrepancies. Marketing lacked
    direct attribution between campaigns and realized revenue. Leadership reviewed reports that required explanation
    rather than confidence.
  </p>
  <p>The business wasn’t losing revenue  it was losing visibility into it.
  </p>
</div>
<div class="container">
  <div class="threeGrid">
    <img src="https://d2lyw5vkb9es5b.cloudfront.net/proven-revenue-smartly-delivered3.webp"
      alt="" class="gridImg">
    <img src="https://d2lyw5vkb9es5b.cloudfront.net/proven-revenue-smartly-delivered4.webp"
      alt="" class="gridImg">
    <img src="https://d2lyw5vkb9es5b.cloudfront.net/proven-revenue-smartly-delivered5.webp"
      alt="" class="gridImg">
  </div>
</div>
<div class="container" style="color:#292929; padding-bottom:6rem;">
  <section class="blogCountUpSection storyBlock">
    <div class="blogCountUpSection__wrapper">

      <div class="blogCountUpSection__left">
        <h1 style="">
          Smarter Systems. Stronger Margins. Sustainable Growth
        </h1>
      </div>

      <div class="blogCountUpSection__right">

        <div class="blogCountUpSection__stat">
          <span class="blogCountUpSection__number">30%</span>
          <p>Revenue uplift</p>
        </div>

        <div class="blogCountUpSection__stat">
          <span class="blogCountUpSection__number">7%</span>
          <p>Reduction in revenue leakage</p>
        </div>

        <div class="blogCountUpSection__stat">
          <span class="blogCountUpSection__number">40%</span>
          <p>Improvement in customer retention</p>
        </div>

      </div>
    </div>
  </section>
</div>
<div class="container storyBlock" style="color:#292929; padding-bottom:6rem;">
  <h2>
    Re-Architecting the Revenue Lifecycle


  </h2>

  <p>
    To eliminate fragmentation at its source, Elements Dining Group unified its commercial operations using <a href="/services/salesforce-implementation" title="Salesforce Sales Cloud Implementation">Salesforce Sales Cloud</a>, <a href="/services/salesforce-revenue-cloud-cpq" title="Salesforce Revenue Cloud CPQ Implementation">Salesforce CPQ</a>, and <a href="/services/salesforce-marketing-cloud" title="Salesforce Marketing Cloud Partner">Salesforce Marketing Cloud</a>.
  </p>

 <p>
    <a href="/services/salesforce-revenue-cloud-cpq" title="Salesforce CPQ for pricing and discount management">Salesforce CPQ</a> centralized all pricing and promotional logic, creating a governed framework where every discount was standardized, validated, and traceable. Sales Cloud transformed reservations into structured revenue records, ensuring that net revenue reflected real-time, accurate pricing. <a href="/services/salesforce-marketing-cloud" title="Salesforce Marketing Cloud campaign attribution">Marketing Cloud</a> connected campaigns directly to transactional outcomes, closing the gap between customer engagement and financial performance.
  </p>
  <p>
    Instead of isolated systems requiring manual intervention, the organization established a connected revenue flow 
    from campaign to reservation to invoice  with pricing integrity embedded at every stage.
  </p>

</div>
<div class="storyBlock" style="
    color:#292929;
    background-image:url('https://d2lyw5vkb9es5b.cloudfront.net/proven-revenue-smartly-delivere6.jpg');
    background-size:cover;
    background-position:top;
    background-repeat:no-repeat;
    width:100%;
    aspect-ratio:20/9;
    margin-bottom:6rem;
  ">
</div>

<div class="container storyBlock" style="color:#292929; padding-bottom:6rem;">
  <h2>
    From Uncertainty to Confidence


  </h2>

  <p>
    The transformation delivered more than system integration. It restored trust across the organization.

  </p>

  <p>
    Guests received invoices that reflected exactly what was promised. Finance gained real-time, audit-ready revenue
    visibility. Marketing could measure true campaign ROI. Leadership operated with a single, reliable source of truth.

  </p>
  <p>
    Revenue no longer required reconciliation to be trusted. It was trusted by design.
  </p>
  <p>With alignment across pricing, sales, and marketing, growth became not just scalable  but sustainable.</p>

</div>

<div />`
  },
  {
    "id": "3",
    "order": 3,
    "imageUrl": "https://backendtestinternal.s3.amazonaws.com/pexels-photo-7445094.jpg",
    "Brandlogo": "https://d2lyw5vkb9es5b.cloudfront.net/PillTim_Logo.png",
    // "backgroundImage": "https://images.pexels.com/photos/7445094/pexels-photo-7445094.jpeg",
    "backgroundImage": "https://d2lyw5vkb9es5b.cloudfront.net/instant-alerts-connected-care0.webp",
    "customer": "PillTime",
    "headline": "Instant Alerts. Connected Care.",
    "detailPageHeadline": "Instant Alerts. Connected Care.",
    "url": "instant-alerts-connected-care",
    "industry": "Pharmacy",
    "description": "Patient lifecycle journeys set up from the point of nomination to prescription to medication check to the delivery keeping patients all-aware of the real-time movement of their medications.",
    "impact": "Early identification of medication and dosage errors leading to high risk situation to be timely notified to the patients and GPs.",
    "techonolgyStack": [
      {
        "id": "1",
        "name": "Salesforce Marketing Cloud"
      },
      {
        "id": "2",
        "name": "Salesforce CRM"
      },
      {
        "id": "3",
        "name": "NHS Spine"
      }
    ],
    "storyDetail": `<div class="container">
  <div class="storyBlock" style="padding:6rem 0; color:#292929;">
    <h2>Making prescription delivery as reliable as the care behind it</h2>

    <p>
      Healthcare is built on trust. For patients, that trust often begins long before treatmentwith
      the confidence that their medication will arrive safely, accurately, and on time.
      For PillTime, delivering medication to thousands of patients across the UK meant managing a
      complex lifecycle that began with NHS prescription nomination and extended through
      validation, packaging, and final delivery.
    </p>

    <p>
      But as prescription volumes scaled beyond 10,000 per day, maintaining real-time visibility across
      this journey became increasingly difficult.
    </p>

    <p>
      Prescription data flowed through NHS Spine and internal operational systems, but without real-
      time synchronization, teams could not always see where prescriptions stood, whether validation
      was complete, or whether risks had emerged.
    </p>

    <p>
      Errors were discovered late. Packaging timelines slowed. Refunds and cancellations increased.
      Most importantly, opportunities to identify medication discrepancies earlywhen intervention
      mattered mostwere at risk.
    </p>

    <p>
      PillTime knew that sustaining safe growth required a fundamentally different approachone
      built on real-time visibility, automation, and connected systems.
    </p>
  </div>
</div>
<div class="storytestimonialContainer" style="color:#292929;">
  <div class="storytestimonialLeftDiv">
    <img src="https://d2lyw5vkb9es5b.cloudfront.net/instant-alerts-connected-care4.webp" alt="Antrazal Blog Image">
  </div>

  <div class="storytestimonialRightDiv">
    <h1 >
      “Excellent support. Always went above and beyond to
      implement the most effective solution in a timely
      manner. Very experienced!”
    </h1>
    <p class="storytestimonialName">Gemma Haggarty</p>
    <p class="storytestimonialRole">Marketing Director, PillTime</p>
  </div>
</div>


<div class="container storyBlock" style="color:#292929; padding-bottom:6rem;">
  <h2>
    Reimagining prescription operations around visibility, safety,
    and scale
  </h2>

  <p>
    PillTime partnered with Antrazal to create a unified, intelligent prescription lifecycle platform
    built on Salesforce.
  </p>

<p>
    Antrazal implemented <a href="/services/salesforce-implementation" title="Salesforce CRM Implementation">Salesforce CRM</a> as the operational backbone and integrated it directly with NHS Spine, ensuring prescription data flowed in real time across systems. This created a single, reliable source of truth across prescription intake, validation, and fulfillment workflows. <a href="/services/salesforce-marketing-cloud" title="Salesforce Marketing Cloud for patient lifecycle communications">Salesforce Marketing Cloud</a> enabled automated lifecycle communications, ensuring patients remained informed as their prescriptions progressed. Instead of relying on manual coordination, operational teams could now see prescription status instantly, identify discrepancies early, and act faster.
  </p>

  <p>
    What was once fragmented became unified. What was once reactive became proactive.
    Prescription lifecycle management was no longer limited by system visibilityit was driven by it.
  </p>
</div>



<div class="container">
    <div class="threeGrid">
        <img src="https://d2lyw5vkb9es5b.cloudfront.net/instant-alerts-connected-care2.webp" alt="" class="gridImg">
        <img src="https://d2lyw5vkb9es5b.cloudfront.net/instant-alerts-connected-care1.webp" alt="" class="gridImg">
        <img src="https://d2lyw5vkb9es5b.cloudfront.net/instant-alerts-connected-care3.webp" alt="" class="gridImg">
    </div>
</div>


<div class="container" style="color:#292929; padding-bottom:6rem;">
  <section class="blogCountUpSection storyBlock">
    <div class="blogCountUpSection__wrapper">

      <div class="blogCountUpSection__left">
        <h1 style="">
         Easy to sticking to a routine efortlessly with PillTime
        </h1>
      </div>

      <div class="blogCountUpSection__right">

        <div class="blogCountUpSection__stat">
          <span class="blogCountUpSection__number">10,000+</span>
          <p>NHS prescriptions processed daily with real-time lifecycle visibility</p>
        </div>

        <div class="blogCountUpSection__stat">
          <span class="blogCountUpSection__number">$500K+</span>
          <p>in refund and cancellation losses redirected to revenue</p>
        </div>

        <div class="blogCountUpSection__stat">
          <span class="blogCountUpSection__number">40%</span>
          <p>reduction in go-to-packaging time, accelerating fulfillment readiness</p>
        </div>

        <div class="blogCountUpSection__stat">
          <span class="blogCountUpSection__number">90%</span>
          <p>of prescription errors identified early, enabling faster intervention and safer patient outcomes</p>
        </div>

      </div>
    </div>
  </section>
</div>
 <div class="blogImageAndQuote storyBlock" style="color:#292929;">
 

   <div class="blogImageAndQuoteRightDiv">
     <h1 >
      "I am committed to transforming the healthcare industry by making medication management more meaningful for patients by combining both physical and digital solutions to empower both patients and their carers."
     </h1>
     <p>Peter Thnoia</p>
     <p>Chief Product and Innovation Office, PillTime</p>
   </div>
 </div>

<div class="container storyBlock" style="color:#292929; padding-bottom:6rem;">
  <h2>The ROI of prescription lifecycle transformation</h2>

  <p>The impact of PillTime’s transformation was immediate and measurable.</p>

 <p>
    By connecting prescription data, operational workflows, and patient communications within <a href="/services/salesforce-implementation" title="Salesforce CRM for pharmacy operations">Salesforce</a>, PillTime reduced delays, strengthened safety controls, and improved operational efficiency at scale.
  </p>

  <p>
    Early identification of prescription errors prevented downstream financial loss while improving
    clinical reliability. Faster packaging readiness accelerated delivery timelines. Real-time lifecycle
    visibility enabled operational teams to scale safely without increasing manual intervention.
    Most importantly, PillTime strengthened the foundation of patient trustensuring that every
    prescription moved through a system designed for accuracy, visibility, and safety.
  </p>
</div>


<div
  class="storyBlock"
  style="
    color:#292929;
    background-image:url('https://d2lyw5vkb9es5b.cloudfront.net/instant-alerts-connected-care5.webp');
    background-size:cover;
    background-position:top;
    background-repeat:no-repeat;
    width:100%;
    aspect-ratio:20/9;
    margin-bottom:6rem;
  ">
</div>


<div class="container storyBlock" style="color:#292929; padding-bottom:6rem;">
  <h2>Building the digital backbone for the future of pharmacy care</h2>

  <p>Today, PillTime operates with a fully connected prescription lifecycle platform powered by <a href="/services/salesforce-implementation" title="Salesforce platform implementation">Salesforce</a>.</p>
  <p>
    Operational teams have real-time insight into prescription status, validation readiness, and fulfillment progression. <a href="/services/salesforce-marketing-cloud-next" title="Salesforce Marketing Cloud automation">Automation</a> ensures patients remain informed and risks are identified early. Leadership has the visibility required to scale confidently.
  </p>
  <p>What began as a need to improve operational visibility became a transformation in how PillTime delivers care.</p>
  <p>With Antrazal as its implementation partner, PillTime has established the digital foundation required to scale safely, operate efficiently, and deliver reliable medication experiences to every patient it serves.</p>

</div>
`
  },
  {
    "id": "4",
    "order": 4,
    "imageUrl": "https://backendtestinternal.s3.amazonaws.com/YMCA-Mombasa.jpg",
    // "backgroundImage": "https://backendtestinternal.s3.amazonaws.com/vision2030MAPPING.jpg",
    "backgroundImage": "https://d2lyw5vkb9es5b.cloudfront.net/powering-vision-2030_6.webp",
    "customer": "World YMCA",
    "headline": "Powering, Vision 2030",
    "detailPageHeadline": "Powering, Vision 2030",
    "url": "powering-vision-2030",
    "industry": "Nonprofit Organization",
    "Brandlogo": 'https://d2lyw5vkb9es5b.cloudfront.net/YMCA_Logo.png',
    "description": "We partnered with YMCA to build an interactive world map platform enabling real-time data exploration and actionable insights.",
    "impact": "By launching a responsive data-driven global site, YMCA enabled teams, partners, and donors to explore metrics, reach, and impact  boosting transparency and engagement.",
    "techonolgyStack": [
      {
        "id": "1",
        "name": "Salesforce Experience Cloud"
      },
      {
        "id": "2",
        "name": "Lightning Web Components"
      },
      {
        "id": "3",
        "name": "D3.js"
      },
      {
        "id": "4",
        "name": "ChartJS"
      },
      {
        "id": "5",
        "name": "Custom APIs"
      }
    ],
    "storyDetail": `<div class="container">
  <div class="storyBlock" style="padding:6rem 0; color:#292929;">
    <h2>When Global Data Lives in Static Reports, Insight Slows Down</h2>

    <p>
    YMCA’s impact spans continents, supporting youth development, community health, education, and social progress initiatives across diverse regions. Its mission is global and its footprint extensive, yet its digital experience did not fully reflect that scale or sophistication.
    </p>

    <p>
    Impact metrics were distributed across multiple regional systems, and country-level reporting required manual consolidation. Leadership teams relied on static dashboards that limited comparative analysis and slowed strategic planning. Donors and partners lacked an intuitive way to visualize reach, performance, and growth across geographies. While the organization possessed strong data assets, accessing meaningful insight required effort, coordination, and time.
    </p>

    <p>
    The challenge was not a shortage of information. It was the limited visibility and accessibility of that information in a format that encouraged exploration and accelerated decision-making.
    </p>
  </div>
</div>
<div class="storytestimonialContainer" style="color:#292929;">
  <div class="storytestimonialLeftDiv">
    <img src="https://d2lyw5vkb9es5b.cloudfront.net/powering-vision-2030_5.webp"
      alt="Antrazal Blog Image">
  </div>

  <div class="storytestimonialRightDiv">
    <h1>
     "We work with Antrazal since they started. They really boost our use of the Salesforce environment. Their major strength: they really put at the maximum the build in features of Salesforce without trying to force us to buy costly third-party solution."
    </h1>
    <p class="storytestimonialName">Claude-Alain Danthe</p>
    <p class="storytestimonialRole">Digital Head, World YMCA</p>
  </div>
</div>


<div class="container storyBlock" style="color:#292929; padding-bottom:6rem;">
  <h2>
Designing a Living, Interactive Global Experience
  </h2>
 <p>
    Antrazal partnered with YMCA to reimagine its digital presence by building a custom Interactive World Map platform within <a href="/services/salesforce-experience-cloud" title="Salesforce Experience Cloud LWR Sites">Salesforce Lightning Web Runtime (LWR)</a>. Rather than layering additional reporting tools on top of existing systems, the objective was to create a unified experience layer that could translate complex global data into an intuitive, interactive environment.
  </p>
  <p>
    The solution integrated D3.js for dynamic global map rendering, enabling users to drill down to country-level views with contextual filters and tooltips. ChartJS was implemented to visualize KPIs, performance indicators, and growth trends in a clear, comparative format. Real-time <a href="/services/salesforce-implementation" title="API integration and custom API development">API integrations</a> ensured that data was dynamically bound to the interface, eliminating reliance on static exports or periodic updates. The architecture was built using modular <a href="/services/salesforce-experience-cloud" title="Lightning Web Components development">Lightning Web Components</a> and designed with a mobile-first approach to ensure global accessibility across devices.
  </p>

  <p>
Users can now navigate the world map, select a region, and immediately explore YMCA’s local footprint, including program reach, performance metrics, and key indicators. The experience feels responsive and immersive, reflecting the scale and ambition of the organization itself.
This is not simply a reporting interface; it is a comprehensive global impact platform that transforms how data is consumed and understood.

  </p>
</div>



<div class="container">
  <div class="threeGrid">
    <img src="https://d2lyw5vkb9es5b.cloudfront.net/powering-vision-2030_1.webp" alt="" class="gridImg">
    <img src="https://d2lyw5vkb9es5b.cloudfront.net/powering-vision-2030_3.webp" alt="" class="gridImg">
    <img src="https://d2lyw5vkb9es5b.cloudfront.net/powering-vision-2030_4.webp" alt="" class="gridImg">
  </div>
</div>


<div class="container" style="color:#292929; padding-bottom:6rem;">
  <section class="blogCountUpSection storyBlock">
    <div class="blogCountUpSection__wrapper">

      <div class="blogCountUpSection__left">
        <h1 style="">
          Building Stronger Futures Across Every Community with World YMCA
        </h1>
      </div>

      <div class="blogCountUpSection__right">

        <div class="blogCountUpSection__stat">
          <span class="blogCountUpSection__number">120+</span>
          <p>Interactive data visualization across global YMCA locations</p>
        </div>

        <div class="blogCountUpSection__stat">
          <span class="blogCountUpSection__number">95%</span>
          <p>Faster Insight Generation</p>
        </div>

        <div class="blogCountUpSection__stat">
          <span class="blogCountUpSection__number">60%</span>
          <p>Reduction in Manual Reporting Effort</p>
        </div>

      </div>
    </div>
  </section>
</div>
<div class="blogImageAndQuote storyBlock" style="color:#292929;">


  <div class="blogImageAndQuoteRightDiv">
    <h1>
      “We are now driven by the clear need to show Impact. That means Data and Evidence, as ways to demonstrate accountability. Data is the only way to prove impact. ”
    </h1>
    <p>Carlos Sanvee</p>
    <p>Secretary General, World YMCA</p>
  </div>
</div>

<div class="container storyBlock" style="color:#292929; padding-bottom:6rem;">
  <h2>The ROI of Transparent Global Engagement</h2>

  <p>Transforming static reporting into an interactive digital experience has delivered strategic value across the organization. Engagement with global performance data has increased, and leadership now benefits from faster insight generation to support planning and investment decisions. Transparency in partner and donor reporting has strengthened confidence, while the scalable architecture ensures that the platform can accommodate future growth.</p>

  <p>
  The transformation represents more than a visual enhancement. It marks a shift from passive data consumption to active data exploration. Instead of reviewing periodic summaries, stakeholders now interact directly with live performance metrics in a way that encourages deeper understanding and more informed decision-making.
  </p>
</div>


<div class="storyBlock" style="
    color:#292929;
    background-image:url('https://d2lyw5vkb9es5b.cloudfront.net/powering-vision-2030_2.webp');
    background-size:cover;
    background-position:top;
    background-repeat:no-repeat;
    width:100%;
    aspect-ratio:20/9;
    margin-bottom:6rem;
  ">
</div>


<div class="container storyBlock" style="color:#292929; padding-bottom:6rem;">
  <h2>A Digital Foundation Built for Global Growth</h2>

  <p>
    Today, YMCA operates on a modern <a href="/services/salesforce-experience-cloud" title="Salesforce Experience Cloud for nonprofits">Salesforce Experience Cloud</a> platform that aligns with the scale of its global mission. Lightning Web Components provide modular flexibility, D3.js and ChartJS power advanced visualization capabilities, and Lightning Web Runtime ensures high performance at scale.
  </p>

  <p>
The platform is designed to evolve alongside the organization. As YMCA expands into new regions, launches new programs, or introduces new measurement frameworks, the digital experience can adapt without structural disruption.
  </p>

  <p>
 Antrazal served as the strategic and engineering partner guiding this transformation. YMCA now owns a scalable, future-ready digital platform that reflects the full scope of its global impact and positions the organization for continued growth and transparency in the years ahead.
  </p>
</div>`,
  },
  {
    "id": "5",
    "backgroundImage": "https://images.pexels.com/photos/1870438/pexels-photo-1870438.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    "customer": "B2B SaaS Scale-up",
    "headline": "Technology-driven colloboration of university and its students",
    "detailPageHeadline": "Technology-driven colloboration of university and its students",
    "industry": "Education",
    "url": "",
    "description": "",
    "impact": "",
    "techonolgyStack": []
  },
  {
    "id": "6",
    "backgroundImage": "https://images.pexels.com/photos/7722927/pexels-photo-7722927.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    "customer": "Pharma",
    "headline": "",
    "detailPageHeadline": "",
    "industry": "Pharma",
    "url": "",
    "description": "",
    "impact": "",
    "techonolgyStack": []
  },
  {
    "id": "7",
    "backgroundImage": "https://images.pexels.com/photos/4058364/pexels-photo-4058364.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    "customer": "Pharma",
    "headline": "",
    "detailPageHeadline": "",
    "url": "",
    "industry": "Pharma",
    "description": "",
    "impact": "",
    "techonolgyStack": []
  },
  {
    "id": "8",
    "backgroundImage": "https://backendtestinternal.s3.amazonaws.com/ChatGPT%20Image%20Jun%2025%2C%202025%2C%2003_32_33%20PM.png",
    // "videoUrl": "https://backendtestinternal.s3.amazonaws.com/doctorHD.webm",
    // "videoUrl": "https://backendtestinternal.s3.amazonaws.com/Untitled%20video%20-%20Made%20with%20Clipchamp%20(1).webm",
    "customer": "A Tesla MRI Lab",
    "headline": "<i>Faster MRI <br></i>appointments and <br>reporting with <b>FHIR</b>",
    "detailPageHeadline": "Faster MRI appointments and reporting with FHIR",
    "industry": "Healthcare",
    "url": "faster-mri-appointments-and-reporting-with-fhir",
    "description": "We helped an emerging US-based Tesla MRI laboratory integrate their DICOM with the CRM to connect the systems for data consistency and fast reports delivery with the patients.",
    "impact": "Effective usage of the machine availability and faster accessibility of the report for the patients.",
    "techonolgyStack": [
      {
        "id": 1,
        "name": "Salesforce CRM"
      },
      {
        "id": 2,
        "name": "Omega AI"
      },
      {
        "id": 3,
        "name": "Ramsoft"
      },
      {
        "id": 4,
        "name": "FHIR APIs"
      }
    ]
  },
  {
    "id": "9",
    "backgroundImage": "https://images.pexels.com/photos/6170456/pexels-photo-6170456.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    "videoUrl": "https://backendtestinternal.s3.amazonaws.com/Moss%20Home.webm",
    "customer": "Moss Home Solutions",
    "headline": "<i>Data-driven<br></i> and in-time Direct Mailing to<b> Home property owners<b>",
    "detailPageHeadline": "Data-driven and in-time Direct Mailing to Home property owners",
    "industry": "Real Estate",
    "url": "data-driven-and-in-time-direct-mailing-to-home-property-owners",
    "description": "Developed an insights and data based direct mail outreach marketing funnel to ingest residential properties data from various sources defining the personalized frequency of mailings basis customer history, engagements, property locality, amenities etc.",
    "impact": "Effective utilization of Direct Mailings budget targeting to the properties, areas and customer that have high probability of selling.",
    "techonolgyStack": [
      {
        "id": "1",
        "name": "Salesforce Marketing Cloud"
      },
      {
        "id": "2",
        "name": "Salesforce CRM"
      },
      {
        "id": "3",
        "name": "8020 CRM"
      },
      {
        "id": "4",
        "name": "Casafy"
      }]
  },
  {
    "id": "10",
    "backgroundImage": "https://images.pexels.com/photos/12935074/pexels-photo-12935074.jpeg?_gl=1*1tge84r*_ga*MTY1NTc2NDU2Ni4xNzQ5MTA5NTgz*_ga_8JE65Q40S6*czE3NTA2NTU1NDUkbzE0JGcxJHQxNzUwNjU3MzE0JGo5JGwwJGgw",
    "videoUrl": "https://backendtestinternal.s3.amazonaws.com/6758573-uhd_3840_2160_24fps.webm",
    "customer": "A chain of fine-dines",
    "headline": "<i>Get the best </i><br>of your marketing <br>with <b>OpenTable</b>",
    "detailPageHeadline": "Get the best of your marketing with OpenTable",
    "industry": "Hospitality",
    "url": "get-the-best-of-your-marketing-with-opentable",
    "description": "Integrated the Klaviyo marketing platform with OpenTable to utilize reservations real-time data triggering the personalized communications to the guests not leaving them left alone and confused.",
    "impact": "Instant customer engagement at the right time to offer hassle-free, enjoying and convenient fine-dining.",
    "techonolgyStack": [
      {
        "id": "1",
        "name": "OpenTable"
      },
      {
        "id": "2",
        "name": "Klaviyo"
      }]
  },
  {
    "id": "11",
    "order": 5,
    // "imageUrl": "https://backendtestinternal.s3.amazonaws.com/DCGbannerImag.jpg",
    "Brandlogo": "https://d2lyw5vkb9es5b.cloudfront.net/seamless-connection-lasting-impact_Logo.webp",
    "backgroundImage": "https://d2lyw5vkb9es5b.cloudfront.net/seamless-connection-lasting-impact1.webp",
    "customer": "Debt Consultants Group",
    "headline": "Seamless Connection. Lasting Impact.",
    "detailPageHeadline": "Seamless Connection. Lasting Impact.",
    "url": "seamless-connection-lasting-impact",
    "industry": "Financial Services",
    "description": "We partnered with Debt Consultants Group (DCG) to transform how financially distressed businesses access relief, guided by a simple but powerful question: What does a business owner need in their most stressful moment?",
    "impact": "",
    "techonolgyStack": [
      {
        "id": "1",
        "name": "Salesforce Sales Cloud"
      },
      {
        "id": "2",
        "name": "Salesforce Marketing Cloud"
      },
      {
        "id": "3",
        "name": "Integrated CRM Architecture (Antrazal Implementation Framework)"
      },
      {
        "id": "4",
        "name": "Automation & Journey Orchestration"
      }
    ],
    "storyDetail": `<div class="container">
  <div class="storyBlock" style="padding:6rem 0; color:#292929;">
    <h2>Making the First Conversation Feel Like Relief</h2>

    <p>
      In a world where businesses can secure funding within hours, debt can spiral just as quickly. Many of DCG’s
      clients come in carrying the weight of daily cash withdrawals, mounting pressure from lenders, and the fear of
      losing everything they’ve built. The hardest step is not restructuring the debt. It is making that first call for
      help.

    </p>

    <p>
      DCG understood that if the entry point into their organization felt confusing or impersonal, trust would erode
      before the relationship even began. They did not simply want to resolve financial cases. They wanted to restore
      confidence from the very first interaction.
    </p>

   <p>
      To achieve that, DCG partnered with Antrazal to modernize its engagement ecosystem through <a href="/services/salesforce-implementation" title="Salesforce Sales Cloud Implementation">Salesforce Sales Cloud</a> and <a href="/services/salesforce-marketing-cloud" title="Salesforce Marketing Cloud for financial services">Salesforce Marketing Cloud</a>, creating a connected experience that meets business owners with clarity, speed, and empathy.
    </p>
  </div>
</div>
<div class="storytestimonialContainer" style="color:#292929;">
  <div class="storytestimonialLeftDiv">
    <img src="https://d2lyw5vkb9es5b.cloudfront.net/seamless-connection-lasting-impact2.webp" alt="Antrazal Blog Image">
  </div>

  <div class="storytestimonialRightDiv">
    <h1>
      “Very process-oriented with pretty structure. I think we have experienced very enhanced version of Salesforce
      delivery with Antrazal team, it was a good one.”
    </h1>
    <p class="storytestimonialName">Rahmid Workfield</p>
    <p class="storytestimonialRole">Project Manager, DCG</p>
  </div>
</div>


<div class="container storyBlock" style="color:#292929; padding-bottom:6rem;">
  <h2>
    Reimagining Access Around What Business Owners Actually Want
  </h2>

  <p>
    As DCG expanded, growth brought complexity. Leads were arriving through digital campaigns, referrals, and inbound
    inquiries, but the information was fragmented. Marketing communications were broad rather than tailored. Advisors
    often lacked full visibility into a prospect’s journey before the first consultation began.

  </p>

  <p>
    For a business owner already under financial stress, repetition and delays only added frustration. Having to restate
    their situation multiple times or wait for follow-ups created unnecessary friction during a critical moment.
  </p>

  <p>
    We stepped back and aligned leadership around a guiding principle: if you were the business owner facing escalating
    debt, what would you expect from a financial partner? The answer was immediacy, personalization, and assurance that
    someone already understood your situation. That principle became the foundation of the transformation.
  </p>
</div>



<div class="container">
  <div class="threeGrid">
    <img src="https://d2lyw5vkb9es5b.cloudfront.net/seamless-connection-lasting-impact4.webp"
      alt="" class="gridImg">
    <img src="https://d2lyw5vkb9es5b.cloudfront.net/seamless-connection-lasting-impact5.webp"
      alt="" class="gridImg">
    <img src="https://d2lyw5vkb9es5b.cloudfront.net/seamless-connection-lasting-impact6.webp"
      alt="" class="gridImg">
  </div>
</div>


<div class="blogImageAndQuote storyBlock" style="color:#292929;">


  <div class="blogImageAndQuoteRightDiv">
    <h1>
      "We value partners who execute with speed and discipline. The team at Antrazal delivered our weekly campaign
      automation workflows on time, with zero issues but engagement, and collaborated seamlessly with our internal
      stakeholders to accelerate delivery. In just one month, they stood up the complete DCG new SFMC environment and
      successfully launched three of our dispositions campaign across both email and SMS channels.”
    </h1>
    <p>Ben Koifman</p>
    <p>Director of IT, DCG</p>
  </div>
</div>

<div class="container storyBlock" style="color:#292929; padding-bottom:6rem;">
  <h2>From Disconnected Processes to One Intelligent Revenue Engine</h2>


  <p>
    The solution was not simply installing new technology. It was designing a connected architecture that unified
    marketing, sales, and client intake into one seamless journey.

  </p>

 <p>
    With <a href="/services/salesforce-marketing-cloud" title="Salesforce Marketing Cloud journey builder">Salesforce Marketing Cloud</a>, inbound inquiries now enter structured, personalized engagement journeys that reflect the specific financial challenges each business faces. Communication is timely, relevant, and educational, helping prospects understand their options before they even speak to an advisor.
  </p>
  <p>
    When that conversation happens, <a href="/services/salesforce-implementation" title="Salesforce Sales Cloud for financial services">Salesforce Sales Cloud</a> ensures advisors have complete context. They can see prior touchpoints, submitted information, engagement history, and case notes in one unified view. Conversations no longer begin at zero. They begin with understanding.
  </p>
  <p>This shift transforms the tone of every interaction. Advisors move from transactional intake to strategic guidance. Instead of collecting information, they focus on solutions. Instead of processing cases, they build trust.</p>
</div>


<div class="storyBlock" style="
    color:#292929;
    background-image:url('https://d2lyw5vkb9es5b.cloudfront.net/seamless-connection-lasting-impact3.webp');
    background-size:cover;
    background-position:top;
    background-repeat:no-repeat;
    width:100%;
    aspect-ratio:20/9;
    margin-bottom:6rem;
  ">
</div>


`
  },
  {
    "id": "12",
    "order": 6,
    "imageUrl": "https://backendtestinternal.s3.amazonaws.com/2a8b30_f9a15c9a693c40439e8b140a463726a4~mv2.jpg",
    "Brandlogo": "https://d2lyw5vkb9es5b.cloudfront.net/where-data-drive-community-changeLogo.webp",
    // "backgroundImage": "https://images.pexels.com/photos/7445094/pexels-photo-7445094.jpeg",
    "backgroundImage": "https://d2lyw5vkb9es5b.cloudfront.net/where-data-drives-community-change1.jpg",
    "customer": "Grove Park Youth Club",
    "headline": "Where Data Drives Community Change",
    "detailPageHeadline": "Where Data Drives Community Change",
    "url": "where-data-drives-community-change",
    "industry": "Nonprofit Organization",
    "description": "We partnered with Grove Park Youth Club to modernize its operations through a structured implementation of Nonprofit Success Pack (NPSP)aligning fundraising, program management, and community engagement around a single, connected CRM foundation.",
    "impact": "",
    "techonolgyStack": [
      {
        "id": "1",
        "name": "Salesforce"
      },
      {
        "id": "2",
        "name": "Nonprofit Success Pack (NPSP)"
      },
      {
        "id": "3",
        "name": "Salesforce Reports & Dashboards"
      },
      {
        "id": "4",
        "name": "Role Hierarchy & Permission Sets"
      }
    ],
    "storyDetail": `<div class="container">
  <div class="storyBlock" style="padding:6rem 0; color:#292929;">
    <h2>Making the mission match the momentum</h2>

    <p>
      Communities today expect the same ease from nonprofits that they experience everywhere else. You can donate,
      register, or sign up for updates in seconds. But behind the scenes, many youth organizations still rely on
      spreadsheets, disconnected systems, and manual tracking.
    </p>

    <p>
      Grove Park Youth Club wanted betterfor its young people, families, donors, and volunteers.
    </p>

    <p>
      As a community-driven nonprofit focused on empowering young people, Grove Park Youth Club was growing. More
      programs. More participants. More supporters. But as activity increased, so did administrative complexity.
    </p>
    <p>“If the experience behind the scenes is fragmented, it impacts how confidently and efficiently we can serve our
      community. We needed our systems to reflect the quality of care we deliver every day.”</p>
    <p>Partnering with Antrazal, Grove Park Youth Club reimagined how it manages relationships, donations, and
      programsproving that when your data foundation is strong, your mission moves faster.</p>
  </div>
</div>
<div class="storytestimonialContainer" style="color:#292929;">
  <div class="storytestimonialLeftDiv">
    <img src="https://d2lyw5vkb9es5b.cloudfront.net/where-data-drives-community-change2.jpg "
      alt="Antrazal Blog Image">
  </div>

  <div class="storytestimonialRightDiv">
    <h1>
      “The community, and especially young people, need a place to creatively congregate. This building has served the
      local people wonderfully and is just the sort of place we need.”
    </h1>
    <p class="storytestimonialName">Robert Clayton</p>
    <p class="storytestimonialRole">Chairman of the Grove Park Youth Club</p>
  </div>
</div>


<div class="container storyBlock" style="color:#292929; padding-bottom:6rem;">
  <h2>
    Reimagining operations around people, not paperwork
  </h2>

  <p>
    Before transformation, critical information lived in different placesdonation records in one system, participant
    data in another, volunteer details elsewhere. Reporting required manual effort. Tracking engagement over time was
    difficult.


  </p>

  <p>
    Leadership faced a challenge familiar to many nonprofits:

  </p>
  <ul>
    <li>Limited visibility into donor lifetime value
    </li>
    <li>Manual reconciliation of recurring donations</li>
    <li>No single source of truth for households and relationships</li>
    <li>Time spent on admin instead of impact</li>
  </ul>
  <p>The question guiding every decision became simple:</p>
  <p><b>What would make it easier to serve young people and strengthen community relationships?
    </b></p>
  <p>That became the north star for building a connected, scalable system designed around peoplenot processes.</p>
</div>



<div class="container">
  <div class="threeGrid">
    <img src="https://d2lyw5vkb9es5b.cloudfront.net/where-data-drives-community-change3.webp" alt="" class="gridImg">
    <img src="https://d2lyw5vkb9es5b.cloudfront.net/where-data-drives-community-change4.webp" alt="" class="gridImg">
    <img src="https://d2lyw5vkb9es5b.cloudfront.net/where-data-drives-community-change5.webp" alt="" class="gridImg">
  </div>
</div>


<div class="container storyBlock" style="color:#292929; padding-bottom:6rem;">
  <h2>
    Our approach
  </h2>

  <p>
    <b>From fragmented records to a unified nonprofit CRM
    </b>

  </p>

  <p>
    To bring Grove Park Youth Club's vision to life, we implemented and configured <a href="/services/salesforce-implementation" title="Salesforce Nonprofit Success Pack NPSP Implementation">Nonprofit Success Pack (NPSP)</a> on Salesforce, creating a single, intelligent foundation for fundraising and program management.
  </p>
  <p>First, we designed a clean data architecture using the Household Account modelensuring every young person, parent,
    donor, and volunteer relationship was structured correctly from day one.
  </p>
  <p>We then configured:
  </p>
  <ul>
    <li>Donation management with standardized opportunity stages

    </li>
    <li>Recurring donation automation</li>
    <li>Soft credits and relationship tracking</li>
    <li>Time spent on admin instead of impact</li>
    <li>GAU allocations for transparent fund tracking</li>
    <li>Engagement plans for structured follow-ups
    </li>
    <li>Role-based access and security</li>
  </ul>
  <p>Instead of juggling spreadsheets, the team now works from one centralized system where every interactiondonation,
    registration, volunteer activityis connected.</p>
  <p>“We’ve moved from reactive administration to proactive engagement. We can see our supporters’ journey clearly and
    act with confidence.”</p>
</div>
<div class="container storyBlock" style="color:#292929; padding-bottom:6rem;">
  <h2>Designing for stronger relationships
  </h2>



 <p>
    By leveraging <a href="/services/salesforce-implementation" title="Salesforce NPSP rollups and relationship mapping">NPSP rollups and relationship mapping</a>, Grove Park Youth Club can now understand:
  </p>


  <ul>

    <li>Total lifetime giving per household</li>
    <li>Program participation history</li>
    <li>Volunteer involvement patterns
    </li>
    <li>Engagement gaps and reactivation opportunities
    </li>
  </ul>
  <p>The shift shows up in meaningful ways. When a long-time supporter increases their recurring donation, the team sees
    it immediately and can respond with personalized appreciation. When a family engages in multiple programs, that
    connection is visible in one placehelping staff deliver more coordinated support.</p>
</div>


<div class="storyBlock" style="
    color:#292929;
    background-image:url('https://d2lyw5vkb9es5b.cloudfront.net/where-data-drives-community-change6.avif');
    background-size:cover;
    background-position:top;
    background-repeat:no-repeat;
    width:100%;
    aspect-ratio:20/9;
    margin-bottom:6rem;
  ">
</div>


`
  },
  {
    "id": "13",
    "order": 1,
    "backgroundImage": "https://d2lyw5vkb9es5b.cloudfront.net/bridging-healthcare-data-gaps1.webp",
    "customer": "Pacific West Diagnostic Imaging",
    "headline": "Bridging healthcare data gaps",
    "detailPageHeadline": "Bridging healthcare data gaps",
    "url": "bridging-healthcare-data-gaps",
    "industry": "Healthcare",
    "Brandlogo": 'https://d2lyw5vkb9es5b.cloudfront.net/bridging-healthcare-data-gaps_Logo.png',
    "description": "The goal was to build a tightly integrated EDI Processor Bridge between Salesforce and their billing systemseliminating manual intervention, reducing reconciliation errors, and enabling real-time operational visibility.",
    "impact": "By implementing a robust EDI bridge fully integrated with Salesforce, Pacific West achieved real-time synchronization between Salesforce and billing systems, automated EDI processing for claims, remittance, and eligibility, reduced manual reconciliation efforts, improved billing accuracy and financial transparency, and faster processing cycles.",
    "techonolgyStack": [
      {
        "id": "1",
        "name": "Integration Strategy & Architecture"
      },
      {
        "id": "2",
        "name": "Salesforce CRM Implementation & Customization"
      },
      {
        "id": "3",
        "name": "Billing System Integration"
      },
      {
        "id": "4",
        "name": "Workflow Automation"
      },
      {
        "id": "5",
        "name": "Data Mapping & Validation Framework"
      }
    ],
    "storyDetail": `<div class="container">
  <div class="storyBlock" style="padding:6rem 0; color:#292929;">
    <h2>When Disconnected Systems Create Operational Friction</h2>
   <p>
      Healthcare billing and insurance processing rely heavily on <a href="/services/edi-processor" title="Healthcare EDI Processing Services">EDI transactions</a>  including claims submissions, eligibility verification, and remittance advice.
    </p>

    <p>
      However, without seamless integration between CRM systems and billing platforms,
      organizations often face:
    </p>

    <ul>
      <li>Manual data entry across systems</li>
      <li>Data mismatches and reconciliation delays</li>
      <li>Limited visibility into claim status</li>
      <li>Increased administrative workload</li>
      <li>Higher risk of billing errors</li>
    </ul>

    <p>
      For Pacific West, improving this process was not just a technical upgrade 
      it was a strategic necessity to enhance operational efficiency and financial accuracy.
    </p>
  </div>
</div>

<div class="storytestimonialContainer" style="color:#292929;">
  <div class="storytestimonialLeftDiv">
    <img src="https://d2lyw5vkb9es5b.cloudfront.net/bridging-healthcare-data-gaps2.avif" alt="Antrazal Blog Image">
  </div>

  <div class="storytestimonialRightDiv">
    <h1>
      "Our mission at Pacific West Medical is to provide healthcare professionals with the most advanced technology and
      dedicated support, ensuring they can deliver the highest standard of patient care”
    </h1>
    <p class="storytestimonialName"> Mark Shaver</p>
    <p class="storytestimonialRole">President, Pacific West Diagnostic Imaging
    </p>
  </div>
</div>

<div class="container">
  <div class="threeGrid">
    <img src="https://d2lyw5vkb9es5b.cloudfront.net/bridging-healthcare-data-gaps3.webp" alt="" class="gridImg">
    <img src="https://d2lyw5vkb9es5b.cloudfront.net/bridging-healthcare-data-gaps4.webp" alt="" class="gridImg">
    <img src="https://d2lyw5vkb9es5b.cloudfront.net/bridging-healthcare-data-gaps5.webp" alt="" class="gridImg">
  </div>
</div>


<div class="container storyBlock" style="color:#292929; padding-bottom:6rem;">
  <h2>
    Engineering a Tight Salesforce–EDI Bridge
  </h2>
 <p>
    Antrazal designed and implemented a fully integrated <a href="/services/edi-processor" title="EDI Processor for healthcare billing automation">EDI Processor Bridge</a> that connects <a href="/services/salesforce-implementation" title="Salesforce CRM for healthcare organizations">Salesforce</a> directly with Pacific West's billing infrastructure.
  </p>

  <p>The solution included:</p>

  <ul>
    <li>Automated inbound and outbound EDI transaction handling</li>
    <li>Real-time data synchronization between Salesforce and billing systems</li>
    <li>Intelligent data validation and transformation logic</li>
    <li>Centralized visibility into transaction status within Salesforce</li>
    <li>Error-handling workflows with alert mechanisms</li>
  </ul>

<p>
    Instead of fragmented processing across multiple tools, the organization now operates within a unified <a href="/services/salesforce-implementation" title="Salesforce implementation services">Salesforce-driven ecosystem</a>.
  </p>

  <p>
    What once required manual oversight is now automated and traceable.<br>
    What once caused delays is now synchronized and efficient.
  </p>

</div>
<div class="storyBlock" style="
    color:#292929;
    background-image:url('https://d2lyw5vkb9es5b.cloudfront.net/bridging-healthcare-data-gaps6.webp');
    background-size:cover;
    background-position:top;
    background-repeat:no-repeat;
    width:100%;
    aspect-ratio:20/9;
    margin-bottom:6rem;
  ">
</div>

<div class="container" style="color:#292929; padding-bottom:6rem;">
  <section class="blogCountUpSection storyBlock">
    <div class="blogCountUpSection__wrapper">

      <div class="blogCountUpSection__left">
        <h1>
          Delivering Operational Accuracy, Financial Transparency, and Accelerated Processing
        </h1>
      </div>

      <div class="blogCountUpSection__right">

        <div class="blogCountUpSection__stat">
          <span class="blogCountUpSection__number">40%</span>
          <p>Faster claims and billing cycle times through automated EDI transaction processing</p>
        </div>

        <div class="blogCountUpSection__stat">
          <span class="blogCountUpSection__number">35%</span>
          <p>Reduction in manual reconciliation workload across Salesforce and billing systems</p>
        </div>

        <div class="blogCountUpSection__stat">
          <span class="blogCountUpSection__number">99%</span>
          <p>Improved billing data accuracy with real-time synchronization and validation logic</p>
        </div>

      </div>
  </section>
</div>


<div class="container storyBlock" style="color:#292929; padding-bottom:6rem;">
  <h2>The ROI of Integrated Healthcare Data Exchange</h2>

  <p>
    By connecting <a href="/services/salesforce-implementation" title="Salesforce CRM implementation for healthcare">Salesforce</a> directly to billing systems through a structured <a href="/services/edi-processor" title="Healthcare EDI processing and automation">EDI bridge</a>:
  </p>

  <ul>
    <li>Data consistency improved across platforms</li>
    <li>Operational costs decreased through automation</li>
    <li>Processing time was significantly reduced</li>
    <li>Leadership gained better reporting and financial oversight</li>
  </ul>

  <p>
    The integration strengthened both operational performance and service delivery standards.
  </p>
</div>


<div class="storyBlock" style="
    color:#292929;
    background-image:url('https://d2lyw5vkb9es5b.cloudfront.net/bridging-healthcare-data-gaps7.avif');
    background-size:cover;
    background-position:top;
    background-repeat:no-repeat;
    width:100%;
    aspect-ratio:20/9;
    margin-bottom:6rem;
  ">
</div>


<div class="container storyBlock" style="color:#292929; padding-bottom:6rem;">
  <h2>Building a Scalable Integration Foundation</h2>
<p>
    Today, Pacific West operates with a tightly integrated <a href="/services/salesforce-implementation" title="Salesforce ecosystem for healthcare administration">Salesforce ecosystem</a> that supports scalable healthcare administration.
  </p>
  <p>With Salesforce as the operational hub and a custom <a href="/services/edi-processor" title="EDI Processor bridge for Salesforce and billing">EDI Processor Bridge</a> powering billing synchronization, the organization has:</p>
  <ul>
    <li>End-to-end transaction visibility</li>
    <li>Automation-driven workflows</li>
    <li>Reduced system silos</li>
    <li>A scalable architecture ready for future growth</li>
  </ul>

  <p>
    Through strategic implementation and deep integration expertise, Antrazal successfully
    translated Pacific West’s vision into a secure, efficient, and tightly integrated Salesforce solution.
  </p>

</div>`
  },
  {
    "id": "14",
    "order": 7,
    "backgroundImage": "https://d2lyw5vkb9es5b.cloudfront.net/24_hr_story_banner.webp",
    "Brandlogo": "https://d2lyw5vkb9es5b.cloudfront.net/24hrHomeCareLogopng.png",
    "customer": "24 Hour Home Care",
    "headline": `A rebuild that made the caregiver's day simpler, and the patient's day quieter.`,
    "detailPageHeadline": `A rebuild that made the <strong style="color:#000000;">caregiver's</strong> day simpler, and the <strong style="color:#000000;">patient's</strong> day quieter.`,
    "url": "24-hour-home-care-workforce-modernization",
    "industry": "Non-medical In-Home Care",
    "description": "A California caregiver workforce supporting older adults, individuals with developmental and intellectual disabilities, and families navigating recovery across the state.",
    "impact": "A calmer daily experience for caregivers, a faster weekly payroll cycle for operations, and a lighter platform foundation ready for what comes next  without touching the operational backbone underneath.",
    "techonolgyStack": [
      {
        "id": "1",
        "name": "Salesforce Field Service"
      },
      {
        "id": "2",
        "name": "Salesforce Marketing Cloud"
      },
      {
        "id": "3",
        "name": "Salesforce Experience Cloud"
      },
      {
        "id": "4",
        "name": "Sandata Integration"
      }
    ],
    "storyDetail": `<div class="container">
  <div class="storyBlock" style="padding:6rem 0; color:#292929;">
    <h2>Care begins at someone’s front door. Everything between the office and that door has to hold.
</h2>
<p>
People hail a ride, pay a bill, and order groceries to the door without thinking about the software that
makes any of it work. The bar for everyday consumer tools has climbed steadily, and it has climbed
without announcing itself.

        </p>

    <p>
  The tools that distributed workforces use to do their jobs have not always kept pace. Across field
service, healthcare, and home-based care, the apps that frontline teams open first in the morning
often grew up alongside the business  built one good intention at a time as the company scaled.
Screens accumulated. Lists grew longer. The small daily frictions that workers absorb without
complaint added up to something the business could feel.

    </p>

   
 <p>24 Hour Home Care knew this terrain well. Founded more than fifteen years ago and headquartered
in El Segundo, the company has become one of California’s established providers of non-medical inhome care  a large caregiver workforce serving clients and families across the state, with visits
moving through its systems every day of the week.
</p>
 <p>Leadership could also see what comes with maturity. The shift-start workflow on the caregiver mobile
app had grown into a multi-screen sequence. The schedule view caregivers referenced throughout
the day surfaced upcoming work in a generic list. The weekly payroll cycle had grown heavier with
each year of scale. None of it was broken. All of it was the natural consequence of building well, for a
long time, at speed.
</p>
  </div>
</div>

<div class="storytestimonialContainer" style="color:#292929;">
  <div class="storytestimonialLeftDiv">
    <img src="https://d2lyw5vkb9es5b.cloudfront.net/24_hr_story_banner_imag_2.webp" alt="Antrazal Blog Image">
  </div>

  <div class="storytestimonialRightDiv">
    <h1>
      "The first thing a caregiver touches in the morning shapes everything that follows. We wanted both ends of the experience  the one our caregivers use and the one our office team relies on  to feel as steady as the care our people deliver.”
    </h1>
    <p class="storytestimonialName">Emily Connolly</p>
    <p class="storytestimonialRole">Project Lead, 24 Hour Home Care
    </p>
  </div>
</div>

<div class="container">
  <div class="threeGrid">
    <img src="https://d2lyw5vkb9es5b.cloudfront.net/image_1_4x5_v2.webp " alt="" class="gridImg">
    <img src="https://d2lyw5vkb9es5b.cloudfront.net/image_2_4x5.webp" alt="" class="gridImg">
    <img src="https://d2lyw5vkb9es5b.cloudfront.net/image_4x5.webp" alt="" class="gridImg">
  </div>
</div>


<div class="container storyBlock" style="color:#292929; padding-bottom:6rem;">
  <h2>
Antrazal stepped into 24HHC’s room. Standups, priorities, calls with the field  all shared.

  </h2>
 <p>
  <b>  Refinement on three surfaces, with the backbone left intact.<b/>
  </p>

  <p>The brief 24 Hour Home Care brought to Antrazal was specific. Three connected outcomes were in
scope: a calmer everyday experience for the caregiver workforce, a faster and more predictable
weekly payroll cycle for the operations team, and a lighter platform footprint ready for what came
next.</p>
<div class="constraint-callout" style="margin-bottom:1.5rem;">
          <div class="constraint-callout__label">The constraint</div>
          <p class="constraint-callout__text">
            The operational backbone could not be touched. The data model held. The Sandata
visit-verification integration the company’s operations run on had to stay exactly as
it was. The compliance posture had to hold.

          </p>
        </div>
 <p>
 That constraint shaped the work more than any technical decision did. The Antrazal team worked in
sessions rather than handoffs  walking through tests with the customer team, flagging items side
by side, figuring them out in the moment. The working rhythm looked less like a vendor delivering a
build and more like a small, focused group of people sitting at the same table.
  </p>

 

</div>
<div class="storyBlock" style="
    color:#292929;
    background-image:url('https://d2lyw5vkb9es5b.cloudfront.net/24_hr_banner_imag3.jpg');
    background-size:cover;
    background-position:top;
    background-repeat:no-repeat;
    width:100%;
    aspect-ratio:20/9;
    margin-bottom:6rem;
  ">
</div>

<div class="container" style="color:#292929; padding-bottom:6rem;">
  <section class="blogCountUpSection storyBlock">
    <div class="blogCountUpSection__wrapper">

      <div class="blogCountUpSection__left">
        <h1>
        A <span style="color:#1012a2;font-weight:400;">platform</span> that holds the weight without being noticed.
        </h1>
      </div>

      <div class="blogCountUpSection__right">

        <div class="">
          <span class="" style="font-weight: 700;">Fewer calls, by design</span>
          <p>A sustained reduction in caregiver support calls on
the modernised screens after launch  a recurring
question that has quietly stopped arriving.</p>
        </div>

        <div class="">
          <span class="" style="font-weight: 700;">One workforce, one experience
</span>
          <p>A statewide caregiver workforce across California
now working from a single, modernised experience.</p>
        </div>

        <div class="">
          <span class="" style="font-weight: 700;">Visits that simply flow</span>
          <p>Caregiver visits moving through a lighter, steadier
platform, week after week.
</p>
        </div>
          <div class="">
          <span class="" style="font-weight: 700;">Felt at the front door</span>
          <p>Clients and families across California meeting a
caregiver who arrives present, not rushed.
</p>
        </div>

      </div>
  </section>
</div>

<div class="container storyBlock" style="color:#292929; padding-bottom:6rem;">
  <h2>Caregivers arrive ready, not rushed. Clients meet a colleague who’s present. The office
spends its day on what matters next.</h2>

  <p>
 <b>The change was felt first in small
moments.<b/></p>

  <p>
 A caregiver opening the app at the start of a shift sees the day’s work, in order, on one screen. The
shift starts with a single task rather than a sequence. When the same caregiver supports two people
living in the same home, the app handles it cleanly. When something at the edge of a shift would
once have meant a quick call to the office, it now resolves in place
  </p>

  <p>
 The Monday morning summary changed the relationship between the company and its workforce in
a quieter way. A category of question  how many hours did I work last week, broken down  that
had run through the office for years stopped arriving by phone. Caregivers got their answer before
they thought to ask.
 </p>
 <p>For the operations team, the weekly payroll cycle became something the calendar could
accommodate again. Edge cases that had once required a manual second look began clearing in the
first pass. Capacity that had been spent inside the cycle returned to the team. The training team
noticed something similar: new caregivers were reaching independent operation faster than the
planned curve.
</p>
 <p>The shift was visible at the leadership level too. A category of support call that had been a constant
in the daily logs stopped appearing. The screens caregivers used most every day looked like the
company they worked for. The platform, for the first time in a while, had room to breathe.</p>
</div>
<div class="blogImageAndQuote storyBlock" style="color:#292929;">
 

   <div class="blogImageAndQuoteRightDiv">
     <h1>
      "What our caregivers see when they open the app is the company, to
them. So when we rebuilt the most-used screen, it wasn’t a cosmetic
change. It was a clearer way of saying: this is your day, on your terms."
     </h1>
     <p>Michael Abe</p>
     <p>Operations, 24 Hour Home Care</p>
   </div>
 </div>

<div class="whatWeSolveBanner" style="margin-bottom:6rem;">
    <div class="container">
        <h2 >Where we put the effort.</h2>


        <div class="whatwesolveSection">
            <div class="what-weSolvedCard">
                <div class="what-we-solve-heading">
                    <p></p>
                    <p style="font-weight: 600;">The screen a caregiver
checks one minute before
knocking.</p>
                </div>
                  <p class="surface__text">A shift that begins with one tap, not five. On Salesforce Field Service, the shift-start became a single task, and the schedule view surfaces the day’s work first, with cleaner handling for two-client homes.</p>
            </div>
            <div class="what-weSolvedCard">
                <div class="what-we-solve-heading">
              <p></p>
                    <p style="font-weight: 600;">The Monday note that arrives instead of a phone call.
</p>
                </div>
                <div class="">
                  <p class="surface__text">A weekly summary that replaced a recurring phone call. A bilingual, mobile-first summary in Salesforce Marketing Cloud reaches each caregiver every week with the prior week’s hours and service types, answering the office’s most common payroll question.</p>
                </div>
            </div>
            <div class="what-weSolvedCard">
                <div class="what-we-solve-heading">
                       <p></p>
                    <p style="font-weight: 600;">The engine no one sees but everyone runs on.</p>
                </div>
               <div class="">
                   <p class="surface__text">A payroll cycle that finally fits the week it belongs in. The weekly payroll approval workflow was rebuilt on a lighter foundation, with automation consolidated across core objects  so work that once stretched across the cycle now clears in a fraction of the time.</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container storyBlock" style="color:#292929; padding-bottom:6rem;">
  <h2>Home care is changing fast. The ground beneath this work is built to keep up.
</h2>
<p>
The longer-term significance is harder to see in a single week and easier to see across a year. The
work created room  for teams, for the platform, and for what comes next.
      </p>
  <p>The operations team has a category of weekly capacity returned to it  hours that had been
absorbed by the payroll cycle and by a recurring class of caregiver call. The training team carries a
lighter onboarding load, with new caregivers finding their footing faster than the curriculum had
assumed they would. The IT team is operating on a platform with reduced automation overhead  a
different working surface than the one inherited at the start of the engagement.</p>
  <p>
  The company’s next moves  scheduling intelligence, automation, AI-supported workflows for the
operations team  sit on a foundation with room for them. New capabilities can be deployed without
retraining the workforce on a tool that has changed underneath them. The platform has headroom.
The caregiver-facing experience has a baseline the company can build on rather than build around.
  </p>

  <p>
 For an industry where the workforce app is, to the people who open it every morning, the company
itself, that baseline matters.
</p>

</div>

<div class="blogImageAndQuote storyBlock" style="color:#292929;">
 

   <div class="blogImageAndQuoteRightDiv">
     <h1>
      "There were moments in this engagement where the partnership felt less
like working with a vendor and more like having extra hands on our own
team. That is a rare thing in our world."
     </h1>
     <p>Sean McCormick</p>
     <p>Project Lead, 24 Hour Home Care</p>
   </div>
 </div>

`
},
  {
    "id": "15",
    "backgroundImage": "/assets/customer-stories/trivago/hero.webp",
    "Brandlogo": "/assets/customer-stories/trivago/trivago.svg",
    "customer": "trivago",
    "headline": "Support portal that lets hoteliers keep pace with traveller demands.",
    "detailPageHeadline": `Support portal that lets <strong>hoteliers</strong> keep pace with <strong>traveller</strong> demands.`,
    "url": "trivago-support-portal",
    "industry": "Travel Technology, Hotel Metasearch",
    "description": "A leading global hotel search platform where millions of travelers compare stays, supported by hundreds of thousands of hoteliers, from independent, family run properties to large chains, across dozens of markets and more than ten languages.",
    "impact": "Faster answers for hoteliers in their own language, a lighter load for the teams who support them, and a scalable self service foundation ready for what comes next, all without pulling hoteliers away from the work of running their properties.",
    "techonolgyStack": [
      {
        "id": "1",
        "name": "Salesforce Experience Cloud (LWR)"
      },
      {
        "id": "2",
        "name": "Salesforce Knowledge"
      },
      {
        "id": "3",
        "name": "Salesforce Service Cloud"
      },
      {
        "id": "4",
        "name": "Multilingual localization"
      },
      {
        "id": "6",
        "name": "Responsive web architecture"
      }
    ],
    "storyDetail": `<div class="container">
  <div class="storyBlock" style="padding:6rem 0; color:#292929;">
    <h2>Behind every listing a traveler compares, someone is running a hotel. When that person has a question, finding the answer should be the easy part.</h2>
    <p>People compare prices, book a room, and plan a whole trip from a phone in minutes, rarely thinking about the software underneath. trivago helped set that expectation. Its promise to travelers has always been that comparing hotels should feel fast, clear, and certain. That bar keeps rising, quietly, everywhere.</p>
    <p>For the hotels on the other side of that search, the experience of getting help hadn't always kept pace with the experience of searching. The hoteliers who manage listings, update content, and run campaigns open these tools as part of a working day already full of guests, staff, and the hundred small decisions a property demands.</p>
    <p>trivago knows this terrain well. A leading global hotel search platform headquartered in Düsseldorf and part of Expedia Group, it works with a network of <strong>hoteliers spanning dozens of markets and more than ten languages</strong>, many of them small, independent businesses managing their own listings, content, and campaigns alongside global chains. Behind the billions of searches travelers run every day sits a hotelier trying to keep a listing accurate, a campaign running, and a business visible.</p>
    <p>Most of the answers hoteliers needed already existed. They were simply spread across documentation and support channels, and finding the right one at the right moment took effort. For a straightforward question, like how to update a listing, how a feature works, how billing is handled, a hotelier often had little choice but to <strong>open a request and wait</strong>. None of it was broken. All of it was the natural consequence of a platform growing fast, across many markets, for a long time.</p>
  </div>
</div>

<div class="storytestimonialContainer" style="color:#292929;">
  <div class="storytestimonialLeftDiv">
    <img src="/assets/customer-stories/trivago/guest-checkin.webp" alt="Hotel guests checking in at a reception desk">
  </div>
  <div class="storytestimonialRightDiv">
    <h1>"Since launching the new help centre, we've been able to handle more hotel support independently, with minimal admin overhead. Most importantly, even as our customer base has grown, our ticket volumes have decreased, a clear sign that we're now truly enabling self service at scale."</h1>
    <p class="storytestimonialName">Marius Tendick</p>
    <p class="storytestimonialRole">Customer Success &amp; Operations Lead, trivago</p>
  </div>
</div>

<div class="container">
  <div class="threeGrid">
    <img src="/assets/customer-stories/trivago/hotel-registration.webp" alt="A guest completing registration at a hotel front desk" class="gridImg">
    <img src="/assets/customer-stories/trivago/trivago-app.webp" alt="The trivago app on a mobile device" class="gridImg">
    <img src="/assets/customer-stories/trivago/hotel-reception.svg" alt="Illustration of a traveler speaking with hotel reception" class="gridImg">
  </div>
</div>

<div class="container storyBlock" style="color:#292929; padding-bottom:6rem;">
  <h2>Antrazal worked from inside trivago's rhythm. Sessions, not handoffs, with every question asked from the hotelier's side of the screen.</h2>
  <p class="lede" style="color:#1012a2!important; font-weight:bold;">One destination, organized around the way hoteliers actually work.</p>
  <p>The brief trivago brought to Antrazal was clear. Three connected outcomes were in scope: answers hoteliers could find on their own, guidance organized around the tasks they actually perform, and an experience that felt native in every market trivago serves.</p>
  <div class="constraint-callout" style="margin-bottom:1.5rem;">
    <div class="constraint-callout__label">The constraint</div>
    <p class="constraint-callout__text">The guidance couldn't simply be lifted from internal product documentation and republished. It had to be reorganized around how hoteliers actually work, and it had to read as clearly in Japanese, Turkish, or Brazilian Portuguese as it did in English, for a family run property and a large chain alike.</p>
  </div>
  <p>That shaped the work more than any single technical decision. The team worked in sessions rather than handoffs, mapping the questions hoteliers ask, grouping them the way a hotelier would, checking how each one read once translated. The rhythm looked less like a vendor shipping a build and more like a small group of people <strong>solving a problem at the same table</strong>.</p>
</div>

<div class="blogImageAndQuote storyBlock" style="color:#292929;">
  <div class="blogImageAndQuoteRightDiv">
    <h1>"From the very first touch point, working with Antrazal felt effortless. The communication was clear and straightforward, and we quickly aligned on a well defined project scope."</h1>
    <p>Marius Tendick</p>
    <p>Customer Success &amp; Operations Lead, trivago</p>
  </div>
</div>

<div class="container storyBlock storyPortalPreview">
  <img src="/assets/customer-stories/trivago/portal-home.webp" alt="trivago Hotelier Support portal home page" class="storyPortalPreview__image">
</div>

<div class="container" style="color:#292929; padding-bottom:6rem;">
  <section class="blogCountUpSection storyBlock">
    <div class="blogCountUpSection__wrapper">
      <div class="blogCountUpSection__left">
        <h1>A <span style="color:#1012a2; font-weight:400;">portal </span> that answers before the question becomes a ticket.</h1>
      </div>
      <div class="blogCountUpSection__right">
        <div class="blogCountUpSection__stat"><span class="blogCountUpSection__number">13</span><p>Languages the support experience speaks, so guidance feels native in every market.</p></div>
        <div class="blogCountUpSection__stat"><span class="blogCountUpSection__number">24/7</span><p>Always on self service, so answers don't wait for office hours.</p></div>
        <div class="blogCountUpSection__stat"><span class="blogCountUpSection__number">6</span><p>Task based categories that helped reduce hotelier support requests by an estimated 15%.</p></div>
        <div class="blogCountUpSection__stat"><span class="blogCountUpSection__number">2B+</span><p>Price comparisons trivago runs for travelers each day, the demand every hotelier is there to win.</p></div>
      </div>
    </div>
  </section>
</div>

<div class="container storyBlock" style="color:#292929; padding-bottom:6rem;">
  <h2>Hoteliers find the answer and get back to their guests. Newcomers get started without a phone call. Support teams spend their day where it's needed most.</h2>
  <p>The change showed up first in small moments.</p>
  <p>A hotelier with a question about a listing or a campaign now finds the answer in a minute or two, from one place, and returns to the property. A question that once meant opening a support request and waiting now <strong>resolves on its own</strong>.</p>
  <p>For someone brand new to the platform, the uncertain first days got easier, with a starter guide instead of a support ticket, a clear path from newly registered to up and running.</p>
  <p>The language barrier quietly fell away. A hotelier in Osaka, São Paulo, or Istanbul reads guidance that feels <strong>written for them, not translated at them</strong>.</p>
  <p>For trivago's support teams, a whole category of routine question <strong>stopped arriving by phone and email</strong>. The hours that had gone to answering the same things, over and over, went back to the hoteliers whose needs are genuinely complex.</p>
  <p>And at the leadership level, the hotelier side of the platform began to feel like the traveler side, clear and consistent across every market, and built on ground the company can keep adding to.</p>
</div>

<div class="blogImageAndQuote storyBlock" style="color:#292929;">
  <div class="blogImageAndQuoteRightDiv">
    <h1>"Antrazal delivered our custom Experience Cloud setup in a remarkably short time frame, with a level of quality and design execution that fully met our expectations. Our help centre is now modern, intuitive, and built for self service."</h1>
    <p>Marius Tendick</p>
    <p>Customer Success &amp; Operations Lead, trivago</p>
  </div>
</div>

<section class="storyEffortBand storyBlock">
  <div class="container">
    <h2>Where we put the effort.</h2>
    <div class="storyEffortBand__grid">
      <article><h3>The place a hotelier checks before calling anyone.</h3><p>A single self service destination on Salesforce Experience Cloud (Lightning Web Runtime), fast and consistent whether a hotelier opens it on a laptop or a front desk phone, where guidance is theirs to find.</p></article>
      <article><h3>Answers organized the way a hotelier thinks.</h3><p>On Salesforce Knowledge, guidance grouped around real hotelier tasks like listing a property, managing content, handling accounts, getting the most from Business Studio, with a prominent search that goes from question to article in seconds.</p></article>
      <article><h3>Help that reads as clearly in Osaka as in Madrid.</h3><p>A localization framework that delivers the experience in more than ten languages, with Salesforce Service Cloud behind it for the moments that still call for a person.</p></article>
    </div>
  </div>
</section>

<div class="container storyBlock storyClosingSection">
  <h2>Travel moves fast, and so does trivago. The ground beneath this work is built to keep up.</h2>
  <p>The longer term significance is easier to see across a year than in a single week. The work created room for hoteliers, for trivago's teams, and for what comes next.</p>
  <p>Support teams have a category of repetitive work returned to them; the capacity that went to answering the same questions now goes to the hoteliers and problems that need real attention.</p>
  <p>The knowledge itself is structured and accessible in a way it wasn't before, the kind of clean foundation that makes future steps, including <strong>AI assisted and conversational support</strong>, far more achievable. New languages, new markets, and new products can join the same experience rather than sit beside it.</p>
  <p>For a marketplace where a hotelier's everyday experience shapes whether they stay and grow with the platform, that baseline matters.</p>
</div>

<div class="blogImageAndQuote storyBlock" style="color:#292929;">
  <div class="blogImageAndQuoteRightDiv">
    <h1>"What started as a scoped project quickly evolved into a broader collaboration. We trusted Antrazal enough to take over both our Salesforce Admin and Marketing Cloud Admin services, a decision we haven't looked back on."</h1>
    <p>Marius Tendick</p>
    <p>Customer Success &amp; Operations Lead, trivago</p>
  </div>
</div>

`
  },
  {
    "id": "16",
    "backgroundImage": "/assets/customer-stories/cambri/08_background.png",
    "Brandlogo": "/assets/customer-stories/cambri/Cambri.svg",
    "customer": "Cambri",
    "headline": "Making ARR easier to explain.",
    "detailPageHeadline": "Making <strong>ARR</strong> easier to explain.",
    "url": "making-arr-easier-to-explain",
    "industry": "Research Technology, Consumer Insights",
    "description": "Cambri is a modern insights platform helping teams test ideas earlier, learn faster, and make better commercial decisions.",
    "impact": "A cleaner Salesforce foundation for ARR visibility, renewal reviews, and leadership reporting without exposing Cambri's private commercial rules.",
    "techonolgyStack": [
      { "id": "1", "name": "Salesforce" },
      { "id": "2", "name": "ARR reporting foundation" },
      { "id": "3", "name": "Revenue operations logic" },
      { "id": "4", "name": "Customer relationship views" },
      { "id": "5", "name": "Quarterly reporting support" }
    ],
    "storyDetail": `<div class="container">
  <div class="storyBlock" style="padding:6rem 0; color:#292929;">
    <h2>ARR had outgrown simple reporting.</h2>
    <p>Cambri had the data. What the business needed was a steadier way to turn that data into an ARR view leaders could use with confidence.</p>
    <p>As the company grew, recurring revenue reporting had to support more customers, more renewal movement, and more reporting moments. The question was no longer whether Salesforce held the information. The question was whether the number was clear enough for sales, finance, revenue operations, and leadership to discuss without a second interpretation later.</p>
    <p>The exact rules behind Cambri's commercial model needed to remain private. Antrazal's role was to strengthen the Salesforce foundation, keep the sensitive logic inside the system, and give teams a clearer ARR signal on top.</p>
    <p>The outcome Cambri needed was simple: ARR that was easier to explain, easier to review, and easier to rely on as the business scaled.</p>
  </div>
</div>

<div class="storytestimonialContainer" style="color:#292929;">
  <div class="storytestimonialLeftDiv">
    <img src="/assets/customer-stories/cambri/03_cambri_team.png" alt="Cambri team">
  </div>
  <div class="storytestimonialRightDiv">
    <h1>"Antrazal helped turn ARR into a number our teams could explain, review, and stand behind."</h1>
    <p class="storytestimonialRole">Cambri Commercial Team</p>
  </div>
</div>

<div class="container">
  <div class="threeGrid">
    <img src="/assets/customer-stories/cambri/04_cambri_meeting_image.png" alt="Cambri team meeting" class="gridImg">
    <img src="/assets/customer-stories/cambri/05_workshop.png" alt="Cambri workshop" class="gridImg">
    <img src="/assets/customer-stories/cambri/06_customer_activity.png" alt="Cambri customer activity" class="gridImg">
  </div>
</div>

<div class="container storyBlock" style="color:#292929; padding-bottom:6rem;">
  <h2>Antrazal translated revenue complexity into a cleaner Salesforce foundation.</h2>
  <p>A stronger ARR view, without exposing the commercial mechanics underneath.</p>
  <p>The work focused on how recurring revenue is calculated, represented, and reviewed inside Salesforce. Cambri needed customer-level visibility, group-level understanding, renewal support, and reporting consistency across time.</p>
  <div class="constraint-callout" style="margin-bottom:1.5rem;">
    <div class="constraint-callout__label">The constraint</div>
    <p class="constraint-callout__text">The implementation had to respect Cambri's private commercial model. The complexity could sit inside Salesforce, but the public story had to stay focused on business outcomes, not internal calculation rules.</p>
  </div>
  <p>Antrazal worked through the operating logic privately with Cambri, then shaped it into a Salesforce foundation that could produce a simpler and more usable ARR view for the teams who depend on it.</p>
</div>

<div style="display:flex; justify-content:center;">
  <div class="storyBlock" style="background-image:url('/assets/customer-stories/cambri/07_team_collaboration.png'); background-size:cover; background-position:center; background-repeat:no-repeat; width:80%; aspect-ratio:16/8; margin-bottom:6rem; border-radius:14px;"></div>
</div>

<div class="container storyBlock" style="color:#292929; padding-bottom:6rem;">
  <h2>A foundation that made ARR easier to trust.</h2>
  <p><strong>One ARR view teams can use.</strong> A clearer Salesforce view that helps teams discuss recurring revenue without manually unpacking every exception.</p>
  <p><strong>Renewal reviews with less back and forth.</strong> A foundation that gives commercial and finance teams a cleaner way to understand movement over time.</p>
  <p><strong>Reporting that can scale.</strong> Current views and periodic reporting can sit on the same operating foundation, making reviews steadier and easier to compare.</p>
  <p>The day-to-day change was practical. Teams could spend less energy questioning the number and more energy using it. Sales could enter renewal conversations with clearer context. Finance could review recurring revenue with more confidence. Revenue operations had a cleaner foundation for reporting and exception handling.</p>
  <p>The value was not that Salesforce exposed more. The value was that Salesforce carried more of the complexity in the background while giving teams a simpler ARR signal to work from.</p>
</div>

<div class="blogImageAndQuote storyBlock" style="color:#292929;">
  <div class="blogImageAndQuoteRightDiv">
    <h1>"The work gave our teams a cleaner way to discuss ARR without opening up the mechanics behind it."</h1>
    <p>Cambri Commercial Team</p>
  </div>
</div>

<div class="whatWeSolveBanner" style="margin-bottom:6rem;">
  <div class="container">
    <h2>Where we put the effort.</h2>
    <div class="whatwesolveSection">
      <div class="what-weSolvedCard"><div class="what-we-solve-heading"><p></p><p style="font-weight:600;">The ARR calculation foundation</p></div><p class="surface__text">Structuring the Salesforce layer so recurring revenue could be represented more consistently across the business.</p></div>
      <div class="what-weSolvedCard"><div class="what-we-solve-heading"><p></p><p style="font-weight:600;">The customer view behind the number</p></div><p class="surface__text">Supporting both detailed customer views and wider relationship views, without making the story depend on private rules.</p></div>
      <div class="what-weSolvedCard"><div class="what-we-solve-heading"><p></p><p style="font-weight:600;">The reporting discipline around it</p></div><p class="surface__text">Giving live and periodic reporting a steadier base so teams can review change with more confidence.</p></div>
    </div>
  </div>
</div>

<div class="container storyBlock" style="color:#292929; padding-bottom:6rem;">
  <h2>More than a reporting fix. A foundation built for scale.</h2>
  <p>The longer term value is not in explaining how Cambri's revenue model works. It is in giving Cambri a Salesforce foundation that can support that model privately and produce a clear ARR view for the business.</p>
  <p>As Cambri grows, ARR reporting can keep pace with new customers, renewals, leadership reviews, finance checks, and commercial planning. The system can absorb complexity internally while keeping the executive view simple.</p>
  <p>Antrazal helped Cambri move toward ARR that is easier to explain, easier to trust, and safer to use as the business scales.</p>
  <div class="constraint-callout" style="margin-top:2rem;">
    <p class="constraint-callout__text">"The outcome was a clearer ARR foundation for the people making decisions every day."</p>
    <div class="constraint-callout__label">Cambri Project Team</div>
  </div>
</div>`
  }
]
